import Swiper, { Pagination, Navigation, Autoplay, EffectFade } from 'swiper'
// import 'swiper/css/effect-fade'

document.addEventListener('app:load', init)

function init ()
{
	if (!document.body.classList.contains('home'))
	{
		return
	}
	
	const sliderSection5 = document.querySelector('section.section-4 .slider')
	
	new Swiper(sliderSection5.querySelector('.swiper'), {
		modules: [Autoplay, Navigation, Pagination, EffectFade],
		slidesPerView: 1,
		speed: 1000,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true
		},
		/*effect: 'fade',
		 fadeEffect: {
		 crossFade: true
		 },*/
		spaceBetween: 0,
		/*navigation: {
		 prevEl: sliderSection5.querySelector('.swiper-button-prev'),
		 nextEl: sliderSection5.querySelector('.swiper-button-next')
		 },*/
		pagination: {
			el: sliderSection5.querySelector('.swiper-pagination'),
			type: 'bullets',
			clickable: true
		},
		breakpoints: {
			1160: {
				slidesPerView: 'auto'
			}
		}
	})
}
